import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "@/components/chat/ChatWidget";
import { LANGUAGES } from "@/i18n";
import { useSmoothScroll, getLenis } from "@/hooks/useSmoothScroll";

const Layout = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useSmoothScroll();

  useEffect(() => {
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
    // Track SPA route changes in Google Analytics 4 (no-op if gtag not loaded)
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    const lang = LANGUAGES.find((l) => i18n.language?.startsWith(l.code));
    document.documentElement.dir = lang?.dir || "ltr";
    document.documentElement.lang = lang?.code || "en";
  }, [i18n.language]);

  // Reveal-on-scroll for elements with class "reveal"
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default Layout;
